import CryptoJS from 'crypto-js';

export function SellertoolSignatureUtils() {
    return {
        generateSigniture: (args = { apiKey: null, secretKey: null, timestamp: null }) => {
            const { apiKey, secretKey, timestamp } = args;
            const message = apiKey + timestamp;
            const signature = CryptoJS.HmacSHA256(message, secretKey).toString(CryptoJS.enc.Hex);
            return signature;
        },
    }
}